import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Grow from '@material-ui/core/Grow';
import CircularProgress from '@material-ui/core/CircularProgress';
import ButtonBase from '@material-ui/core/ButtonBase';

import styles from './styles';
import { GrowTransition } from '../../../../../ui-components/utils';
import StatusPositive from '../../../../../resources/vectors/status_positive';
import { Link } from 'react-router-dom';
import { gc } from '../../../../../services/Localisation';

class LoaderDialog extends React.Component {
    
    translation_key = 'properties_translations';

    render = () => <Dialog maxWidth='sm' open={this.props.open} TransitionComponent={GrowTransition}>
        <div style={styles.content}>
            <Grow in={this.props.mode === 'loading'}><div style={styles.loader} className='fillSpace'>
                <CircularProgress /><div style={styles.authenticating}>{gc(this.translation_key,this.props.loadingText)}</div>
            </div></Grow>
            <Grow in={this.props.mode === 'success'}><div style={styles.success} className='fillSpace'>
                <div style={styles.success_content}>
                    <StatusPositive /><div style={styles.success_text}>{gc(this.translation_key,this.props.successText)}</div>
                </div>
                <Link to={this.props.actionRoute} onClick={this.props.dialogAction}>
                <ButtonBase style={styles.success_footer} >{gc(this.translation_key,this.props.actionText)}</ButtonBase>
                </Link>
            </div></Grow>
        </div>
    </Dialog >;

}

LoaderDialog.defaultProps = {
    dialogAction : () => {}
}

export default LoaderDialog;